<template>
  <div>
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-menu
        v-if="
          $permission.permissionAllow('MaterialTemplates', 'singleBatchSave') &&
          template.id
        "
        v-model="btnMenu"
        close-on-click
        close-on-content-click
        offset-x
        offset-overflow
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop=""
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Template.batchSave.title") }}
            <v-icon x-small class="ps-1">
              {{ btnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { add_material: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.addMaterial") }}
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
            @click.stop="singleBatchSave(template.id, { status: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.status_one") }}
            </v-list-item-title>
          </v-list-item> -->
          <v-list-item
            @click.stop="singleBatchSave(template.id, { status: 0 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.status_zero") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { hide_flg: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.hide_flg_one") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { hide_flg: 0 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.hide_flg_zero") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { is_follow: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.is_follow_one") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { is_follow: 0 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.is_follow_zero") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { default_unit: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.default_unit") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="singleBatchSave(template.id, { max_unit: 1 })"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.max_unit") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="settings && settings.service_charge_enable"
            @click.stop="serviceChargeDialog = true"
          >
            <v-list-item-title>
              {{ $t("Template.batchSave.service_charge") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
    <DialogServiceCharge
      v-model="serviceChargeDialog"
      :template-id="template.id"
    />
  </div>
</template>

<script>
import MaterialTemplates from "@/api/material_templates";
import DialogServiceCharge from "./DialogServiceCharge.vue";
import {mapState} from "vuex";

export default {
  name: "Actions",

  components: {
    DialogServiceCharge
  },

  props: {
    template: Object,
    showPrint: Boolean,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    btnMenu: false,
    serviceChargeDialog: false,
  }),

  methods: {
    singleBatchSave(id, data) {
      // this.$store.dispatch("fullscreenLoading");
      MaterialTemplates.singleBatchSave(id, data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$emit("update");
          }
          // this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },
  watch: {},
};
</script>